export default __webpack_public_path__ + "static/media/cdclogo.7b55d379.png";